import { Link } from "react-router-dom";
import {
  PaintRoller, Home as HomeIcon, Wrench, Layers, Hammer, Droplets,
  Square, Grid3X3, Pipette, Frame, Warehouse, Compass, ArrowRight, Phone
} from "lucide-react";
import { SERVICES, SITE } from "../lib/site";

const ICONS = { PaintRoller, Home: HomeIcon, Wrench, Layers, Hammer, Droplets, Square, Grid3X3, Pipette, Frame, Warehouse, Compass };

export default function Services() {
  return (
    <>
      <section className="section pt-16 md:pt-24" data-testid="services-hero">
        <div className="container-luxury">
          <p className="overline">What We Do</p>
          <h1 className="mt-4 font-display text-5xl sm:text-6xl lg:text-7xl text-white font-light leading-[1.05] max-w-4xl">
            Services for every <span className="font-script text-[var(--gold)]">surface</span> of your home
          </h1>
          <p className="mt-6 text-white/60 text-lg max-w-2xl">
            Twelve premium services — delivered by a single, accountable team you can call by name.
            Every project backed by a 1-year warranty.
          </p>
        </div>
      </section>

      <section className="pb-24" data-testid="services-grid-section">
        <div className="container-luxury">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-white/5">
            {SERVICES.map((s) => {
              const Icon = ICONS[s.icon] || PaintRoller;
              return (
                <div
                  key={s.slug}
                  className="bg-[#0A0A0A] p-10 group hover:bg-[#141414] transition-colors relative"
                  data-testid={`service-card-${s.slug}`}
                >
                  <div className="flex items-start justify-between">
                    <div className="w-14 h-14 border border-[var(--gold)]/30 flex items-center justify-center group-hover:border-[var(--gold)] transition-colors">
                      <Icon size={24} className="text-[var(--gold)]" />
                    </div>
                    <span className="text-xs text-white/30 uppercase tracking-[0.2em]">0{(SERVICES.indexOf(s) + 1).toString().padStart(2, "0")}</span>
                  </div>
                  <h3 className="mt-8 font-display text-2xl md:text-3xl text-white">{s.title}</h3>
                  <p className="mt-3 text-white/55 leading-relaxed">{s.description}</p>
                  <div className="mt-8 flex gap-3">
                    <Link to="/contact" className="text-[var(--gold)] text-xs uppercase tracking-[0.2em] link-underline" data-testid={`service-estimate-${s.slug}`}>
                      Free Estimate →
                    </Link>
                    <a href={SITE.phoneHref} className="text-white/60 text-xs uppercase tracking-[0.2em] link-underline" data-testid={`service-call-${s.slug}`}>
                      Call
                    </a>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <section className="section bg-[#0c0c0c]" data-testid="services-cta">
        <div className="container-luxury text-center">
          <h2 className="font-display text-4xl md:text-5xl text-white font-light">
            Not sure where to start? <br />
            <span className="font-script text-[var(--gold)]">We'll guide you.</span>
          </h2>
          <p className="mt-6 text-white/60 text-lg max-w-2xl mx-auto">
            Tell us about your project — we'll walk the property, propose the right scope, and give you a
            transparent estimate.
          </p>
          <div className="mt-10 flex flex-wrap gap-4 justify-center">
            <Link to="/contact" className="btn-primary" data-testid="services-cta-estimate">
              Request Free Estimate <ArrowRight size={16} />
            </Link>
            <a href={SITE.phoneHref} className="btn-secondary" data-testid="services-cta-call">
              <Phone size={16} /> {SITE.phone}
            </a>
          </div>
        </div>
      </section>
    </>
  );
}
